import { withWidth } from "@material-ui/core"
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints"
import { NextComponentType } from "next"
import * as React from "react"
import { compose } from "react-apollo"
import { isMobileResolution } from "../../utils/style"

interface WrappedComponentProps {
    isMobile: boolean
}
interface Props {
    width: Breakpoint
}

const withIsMobile = <P extends WrappedComponentProps>(WrappedComponent: NextComponentType<P>) =>
    class WithIsMobile extends React.Component<P & Props> {
        render() {
            return <WrappedComponent {...this.props} isMobile={isMobileResolution(this.props.width)} />
        }
    }

export default compose(
    withWidth({ withTheme: true }), // withTheme: true, otherwise the withWidth hoc remove theme from wrapped component
    withIsMobile
)
